import Image from "next/image";
import { CAPABILITIES, SECTION_IDS } from "./content";
import { Reveal } from "./reveal";

export const Capabilities = () => (
  <section id={SECTION_IDS.capabilities} className="dc-section">
    <div className="dc-shell">
      <div className="mb-[clamp(48px,6vw,84px)] grid items-end gap-x-[clamp(32px,5vw,90px)] gap-y-[22px] lg:grid-cols-2">
        <h2 className="m-0 max-w-[18ch] text-[clamp(34px,5vw,82px)] font-bold leading-[.98] tracking-[-.04em] text-balance">
          Capabilities built around your needs.
        </h2>
        <p className="m-0 max-w-[46ch] text-[clamp(17px,1.4vw,20px)] leading-[1.7] text-mist-2">
          One archive, one engine, one team that understands both the data and
          the landscapes it describes.
        </p>
      </div>

      {/* The design narrowed the card basis (320px -> 240px, min 230px) to keep
          the groups on one row further down the width range. Fixed breakpoints
          rather than auto-fit: with four groups, auto-fit strands the fourth
          full-width across a wide band of mid-size screens. */}
      <div className="grid grid-cols-1 gap-[clamp(24px,3vw,40px)] sm:grid-cols-2 xl:grid-cols-4">
        {CAPABILITIES.map((capability, index) => (
          <Reveal
            key={capability.kicker}
            delay={index * 90}
            className="group flex min-w-0 flex-col"
          >
            <div className="relative mb-[26px] h-[clamp(150px,15vw,220px)] overflow-hidden">
              <Image
                src={capability.img}
                alt={capability.alt}
                fill
                sizes="(max-width: 768px) 100vw, 33vw"
                className="object-cover saturate-[.8] transition-transform duration-[800ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(3,12,22,.32),rgba(3,12,22,.9))]" />
              <div
                className="dc-mono absolute bottom-4 left-[18px] text-[12px] uppercase tracking-[.18em]"
                style={{ color: capability.kickerColor }}
              >
                {capability.kicker}
              </div>
            </div>

            <h3 className="mt-0 mb-3.5 text-[clamp(21px,2vw,28px)] font-semibold leading-[1.12] tracking-[-.022em] text-balance">
              {capability.title}
            </h3>
            <p className="mt-0 mb-5 text-[17px] leading-[1.7] text-mist-2">
              {capability.body}
            </p>

            <ul className="mx-0 mb-0 mt-auto grid list-none gap-[11px] border-t border-white/[.14] p-0 pt-[18px]">
              {capability.items.map((item) => (
                <li
                  key={item}
                  className="grid grid-cols-[14px_minmax(0,1fr)] gap-2.5 text-base leading-[1.55] text-mist-2"
                >
                  <span className="text-cyan">+</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
